import { render } from "./SyntheticObjects.vue?vue&type=template&id=56e1bb3f"
import script from "./SyntheticObjects.vue?vue&type=script&lang=js"
export * from "./SyntheticObjects.vue?vue&type=script&lang=js"

import "./SyntheticObjects.vue?vue&type=style&index=0&id=56e1bb3f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__